// export default () => ({
// })

export default () => ({
    racks: [],
    racksSelectable: [],
    racksPaginatedData: null,
    rack: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})